// 自动生成，请勿手动修改

import { observer } from 'mobx-react'
import AntIcon from '@ant-design/icons'
import type { GetProps } from 'antd'
import { SvgIcons } from './IconData'
import { ImgIcons } from './IconData'

export type IconProps = GetProps<typeof AntIcon> & {
  name: keyof typeof SvgIcons
}

export const Icon = observer(({ name, ...props }: IconProps) => {
  return <AntIcon component={SvgIcons[name]} {...props} />
})

export interface IconImgProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  src: keyof typeof ImgIcons
}

export const IconImage = observer(({ src, ...props }: IconImgProps) => {
  const icon = require(`../../assets/images/${ImgIcons[src]}`)
  return <img draggable={false} src={icon} alt='' {...props} />
})